export const visionProducts = [
  {
    value: 'AM_VISION',
    label: 'Asset Management for Vision',
  },
];

// Products whose entry in `productDetails` is keyed by the order's facility names rather than
// by fixed field names, e.g. `productDetails.AM_VISION['Gym A'].amVisionTouchscreenCount`.
// Those keys need special handling on the API round-trip and when re-reading a saved order —
// see libs/helpers/facilityKeys.ts and api/orderKeyConversion.ts.
export const facilityKeyedProductDetails: readonly string[] = ['iFIT', 'FACILITY360', 'AM_VISION'];

export const isFacilityKeyedProductDetail = (name: string): boolean =>
  facilityKeyedProductDetails.includes(name);

export const products = [
  {
    value: 'AM',
    label: 'Asset Management',
  },
  {
    value: 'COM360',
    label: 'Community 360',
  },
  {
    value: 'ENG360',
    label: 'Engage 360',
  },
  {
    value: 'FACILITY360',
    label: 'Facility 360 powered by Ecofit',
  },
  {
    value: 'FACILITY_CONCIERGE',
    label: 'Facility Concierge (Onyx ONLY)',
  },
];

export const integrations = [
  {
    value: 'EGYM',
    label: 'EGYM',
  },
  {
    value: 'PACE',
    label: 'PACE (Matrix | seca)',
  },
  {
    value: 'ECOFIT',
    label: 'Ecofit',
  },
  {
    value: 'YMCA360',
    label: 'YMCA360',
  },
  {
    value: 'iFIT',
    label: 'iFIT',
  },
  {
    value: 'other',
    label: 'Other',
  },
];
